import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import Fa from 'react-fontawesome';

class CheckboxCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  componentDidMount() {
    this.toggleValue();
  }

  getValue() {
    return this.state.value;
  }

  toggleValue() {
    const isFalse = this.state.value === false || this.state.value === null || this.state.value === undefined;
    this.setState({ value: !!isFalse }, () => {
      delay(() => {
        this.props.api.stopEditing();
      }, 100);
    });
  }
  render() {
    const { value } = this.props;
    return (
      <div style={{ padding: '5px 11px 0' }}>
        <Fa
          style={{ cursor: 'pointer', fontSize: '1.3em' }}
          name={value ? 'check-square-o' : 'square-o'}
          className={value ? 'text-success' : 'text-muted'}
        />
      </div>
    );
  }
}


CheckboxCell.propTypes = {
  value: PropTypes.bool,
  api: PropTypes.shape({
    stopEditing: PropTypes.func.isRequired,
  }).isRequired,
};
CheckboxCell.defaultProps = {
  value: false,
};

export default CheckboxCell;
